import { ANALYTICS_EVENT, type Analytics } from './analytics';

/**
 * The privacy page's switch: says whether visits are being counted and turns
 * it on or off. The page is plain HTML and keeps the switch hidden until this
 * runs, so it never shows where analytics is off.
 *
 * Markup (build/content-pages.ts): `[data-analytics-choice]` with the words in
 * `data-granted`, `data-denied`, `data-unset`, `data-turn-on` and
 * `data-turn-off`, holding `[data-choice-status]` and `button[data-choice-toggle]`.
 */
export function setUpAnalyticsChoice(element: HTMLElement, analytics: Analytics): () => void {
  const status = element.querySelector<HTMLElement>('[data-choice-status]');
  const toggle = element.querySelector<HTMLButtonElement>('button[data-choice-toggle]');
  const win = element.ownerDocument.defaultView;
  if (!status || !toggle || analytics.state() === 'off') return () => undefined;
  const words = element.dataset;

  const render = () => {
    const state = analytics.state();
    const on = state === 'granted';
    element.dataset.state = state;
    status.textContent = (on ? words.granted : state === 'denied' ? words.denied : words.unset) ?? '';
    toggle.textContent = (on ? words.turnOff : words.turnOn) ?? '';
  };
  const onClick = () => (analytics.state() === 'granted' ? analytics.deny() : analytics.grant());

  render();
  element.hidden = false;
  toggle.addEventListener('click', onClick);
  win?.addEventListener(ANALYTICS_EVENT, render);
  return () => {
    toggle.removeEventListener('click', onClick);
    win?.removeEventListener(ANALYTICS_EVENT, render);
  };
}
